module.exports = __webpack_public_path__ + "img/simpleui_projector_lx_down.36e42e31.png";